module.exports = __webpack_public_path__ + "static/New__Donate__page_on_upReach_website-f395b89f07707539a2191ff84ddc5012.png";